import { impersonateStartBody } from '@planuze/admin-contracts';
import { copyTextToClipboard, toast } from '@planuze/ui';
import { useUsersContent } from '../../../content/sections/users.js';
import { useStaffSession } from '../../../hooks/use-staff-session.js';
import { useImpersonate } from '../../../hooks/use-users.js';
import { ReasonDialog } from '../../reason-dialog.js';
import { userErrorMessage } from '../user-error.js';

interface Props {
  readonly open: boolean;
  readonly onClose: () => void;
  readonly userId: string;
  readonly userEmail: string;
}

/* Impersonation (super_admin): emite o token e entrega via área de transferência — NUNCA
   na URL do `window.open` (§4.9/§4.15). URL de custom scheme fica visível no endereço/
   histórico do browser e no argv do processo quando o SO despacha o handler — superfícies
   observáveis fora do runtime JS (screen-share, logs de lançamento de processo), mesmo
   quando não há handler registrado (a aba fica parada mostrando a URL com o token). O
   `planuze://impersonate` ainda é aberto, só sem o token, para focar/abrir o desktop; o
   consumidor que lê a área de transferência é follow-up (ADR-0356). */
export function ImpersonateModal({ open, onClose, userId, userEmail }: Props) {
  const copy = useUsersContent();
  const session = useStaffSession();
  const impersonate = useImpersonate(userId);
  const confirm = (reason: string): void => {
    impersonate.mutate(reason, {
      onSuccess: (data) => {
        const url =
          'planuze://impersonate?' +
          `expiresAt=${encodeURIComponent(data.expiresAt)}` +
          `&staffId=${encodeURIComponent(session?.id ?? '')}`;
        window.open(url, '_blank');
        copyTextToClipboard(data.token).then((didCopy) => {
          if (didCopy) {
            toast.success(copy.impersonateModal.success(data.userEmail));
          } else {
            toast.error(copy.impersonateModal.copyFailed);
          }
        });
        onClose();
      },
      onError: (err) => {
        toast.error(userErrorMessage(err, copy.errors));
      },
    });
  };
  return (
    <ReasonDialog
      open={open}
      onClose={onClose}
      title={copy.impersonateModal.title(userEmail)}
      description={copy.impersonateModal.description}
      confirmLabel={copy.impersonateModal.confirmLabel}
      reasonLabel={copy.impersonateModal.reasonLabel}
      pending={impersonate.isPending}
      validate={(reason) => impersonateStartBody.safeParse({ reason }).success}
      onConfirm={confirm}
    />
  );
}
